import React from 'react';

import PropTypes from 'prop-types';
import { Tooltip } from 'antd';

export default function Dot({ color = '#fff', size, tip }) {
  const dot = (
    <div style={{ backgroundColor: color }} className={`dot ${size}`} />
  );
  if (tip) {
    return (
      <Tooltip
        placement="bottom"
        title={<span className="company-history-dot-tip">{tip}</span>}
      >
        {dot}
      </Tooltip>
    );
  }

  return dot;
}

Dot.defaultProps = {
  tip: null,
  size: 'lg',
};

Dot.propTypes = {
  tip: PropTypes.string,
  size: PropTypes.oneOf(['lg', 'sm']),
  color: PropTypes.string.isRequired,
};
